import { PROGRAM, PROGRAMS } from "@bussola-viagens/constants"
import { useTabs } from "@mui/base"
import { Box, Tab, Tabs } from "@mui/material"
import { Grid, Layout, Paper } from "../../components"
import { Cancelation } from "./Cancelation"
import { Repricing } from "./Repricing"
import { AdditionalServices } from "./AdditionalServices"

export const AfterSalesCalculatorPage = () => {
    const tabs = useTabs({
        defaultValue: 1
    })

    return (
        <Layout>
            <Grid container p={2} spacing={1} justifyContent={'center'}>
                <Grid item xs={12}>
                    <Paper>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabs.contextValue.value} onChange={tabs.contextValue.onSelected}>
                                <Tab label={'Cancelamento'} value={1} />
                                <Tab label={'Remarcação'} value={2} />
                                <Tab label={'Serviços Adicionais'} value={3} />
                            </Tabs>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={8}>
                    {tabs.contextValue.value === 1 && (<Paper style={{
                        padding: 15,
                    }}>
                        <Cancelation />
                    </Paper>)}
                    {tabs.contextValue.value === 2 && (<Paper style={{
                        padding: 15,
                    }}>
                        <Repricing />
                    </Paper>)}
                    {tabs.contextValue.value === 3 && (<Paper style={{
                        padding: 15,
                    }}>
                        <AdditionalServices />
                    </Paper>)}
                </Grid>
            </Grid>
        </Layout>
    )
}